import { tsPlugin } from './tsPlugin'

export = tsPlugin
